// ─── Portal Broker — Context + Zustand store ─────────────────

import React, { createContext, useContext } from 'react';
import { create } from 'zustand';
import { PORTAL_BROKER_TOKEN_KEY } from '@api/portal';

interface PortalBrokerState {
  token:    string | null;
  brokerId: number | null;
  nombre:   string | null;
  setAuth:  (token: string, brokerId: number, nombre: string) => void;
  clearAuth: () => void;
}

const usePortalBrokerStore = create<PortalBrokerState>((set) => ({
  token:    localStorage.getItem(PORTAL_BROKER_TOKEN_KEY),
  brokerId: null,
  nombre:   null,
  setAuth: (token, brokerId, nombre) => {
    localStorage.setItem(PORTAL_BROKER_TOKEN_KEY, token);
    set({ token, brokerId, nombre });
  },
  clearAuth: () => {
    localStorage.removeItem(PORTAL_BROKER_TOKEN_KEY);
    set({ token: null, brokerId: null, nombre: null });
  },
}));

const PortalBrokerContext = createContext<PortalBrokerState | null>(null);

export const PortalBrokerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const store = usePortalBrokerStore();
  return (
    <PortalBrokerContext.Provider value={store}>
      {children}
    </PortalBrokerContext.Provider>
  );
};

export const usePortalBroker = (): PortalBrokerState => {
  const ctx = useContext(PortalBrokerContext);
  if (!ctx) throw new Error('usePortalBroker must be used within PortalBrokerProvider');
  return ctx;
};
